/* eslint-disable */
import React, { useContext } from 'react';
import { Data, Filters } from '../contexts';
import { parseMoney } from '../../utils';
import { YTDCashFlowValues, MonthlyCashFlowValues, CashFlowCommonSizeArrows } from '../report_components/MoneyHelpers';

const getYTDMonthCount = (data, ytdMonths) => {
    if (!data || !Array.isArray(ytdMonths)) return 0;
    return ytdMonths.filter((m) => _.isNumber(data[m])).length;
};

const getYTDMonths = (data, ytdMonths) => {
    if (!data || !Array.isArray(ytdMonths)) return [];
    return ytdMonths.map((m) => data[m]);
};

const monthNames = {
  1: 'JAN',
  2: 'FEB',
  3: 'MAR',
  4: 'APR',
  5: 'MAY',
  6: 'JUN',
  7: 'JUL',
  8: 'AUG',
  9: 'SEP',
  10: 'OCT',
  11: 'NOV',
  12: 'DEC',
};

const MoneyYTDCashFlow = (props) => {
    const { monthly_calcs, ytd_months } = useContext(Data);
    const { filters } = useContext(Filters);
    let finalFilters = props.tabFilters || filters;
    const reportPeriod = finalFilters.report_period;
    const avgCalcs = props.aggregateData ? props.aggregateData?.monthly : monthly_calcs;
    const compareWith = finalFilters.compare_with;
    const selectedYear = finalFilters.year;
    const previousYear = finalFilters.year - 1;
    const twoYearsAgo = finalFilters.year - 2;
    const selectedYearEndDigits = selectedYear ? selectedYear.toString().slice(-2) : '';
    const previousYearEndDigits = previousYear ? previousYear.toString().slice(-2) : '';
    let numberCompare;
    if (finalFilters && compareWith === 'Default:YOY') {
        numberCompare = 'n = 1'
    } else {
        numberCompare = `n = ${props.aggregateData?.monthly_avg_n?.[selectedYear] ?? 0}`;
    }

    const youSelectedYearTotalRevenue = monthly_calcs?.you?.total_revenue?.[selectedYear] || {};
    const youPreviousYearTotalRevenue = monthly_calcs?.you?.total_revenue?.[previousYear] || {};
    const youSelectedYearYTDRevMonths = getYTDMonths(youSelectedYearTotalRevenue, ytd_months);
    const youPreviousYearYTDRevMonths = getYTDMonths(youPreviousYearTotalRevenue, ytd_months);
    const youSelectedYearYTDRevenue = Object.values(youSelectedYearYTDRevMonths).reduce((a, b) => a + b, 0)
    const youPreviousYearYTDRevenue = Object.values(youPreviousYearYTDRevMonths).reduce((a, b) => a + b, 0)

    const compareSelectedYearTotalRevenue = avgCalcs?.avg?.total_revenue?.[selectedYear];
    const comparePreviousYearTotalRevenue = avgCalcs?.avg?.total_revenue?.[previousYear];
    const compareSelectedYearYTDRevMonths = getYTDMonths(compareSelectedYearTotalRevenue, ytd_months);
    const comparePreviousYearYTDRevMonths = getYTDMonths(comparePreviousYearTotalRevenue, ytd_months);
    const compareSelectedYearYTDRevenue = Object.values(compareSelectedYearYTDRevMonths).reduce((a, b) => a + b, 0)
    const comparePreviousYearYTDRevenue = Object.values(comparePreviousYearYTDRevMonths).reduce((a, b) => a + b, 0)

    const firstYearMonth = getYTDMonthCount(youPreviousYearTotalRevenue, ytd_months)
    const secondYearMonth = getYTDMonthCount(youSelectedYearTotalRevenue, ytd_months)
    const clientFirstYearMonth = firstYearMonth < 10 ? '0' + firstYearMonth.toString() : firstYearMonth;
    const clientSecondYearMonth = secondYearMonth < 10 ? '0' + secondYearMonth.toString() : secondYearMonth;
    // Ex. Selected Year is 2021
    // YTD for selectedYear, previousYear (2021, 2020)
    // Full Months for prevoiusYear, twoYearsAgo (2020, 2019)

    // const calcsYou = monthly_calcs[newYear].you;
    // const calcsPeers = compareWith === 'Peers' ? monthly_calcs[newYear].avg : null;
    // Ex. 2020
    // const calcsYouOldYear = monthly_calcs[oldYear].you;
    // const calcsPeersOldYear = compareWith === 'Peers' ? monthly_calcs[oldYear].avg : null;
    // 2020 Full Year
    // const previousYearCalcsYou = previousYearCalcs['monthly_full_year'][previousNewFullYear].you;
    // const previousYearCalcsPeers = compareWith === 'Peers' ? previousYearCalcs['monthly_full_year'][previousNewFullYear].avg : null;
    // 2019 Full Year
    // const previousYearCalcsYouOldYear = previousYearCalcs['monthly_full_year'][previousOldFullYear].you;
    // const previousYearCalcsPeersOldYear = compareWith === 'Peers' ? previousYearCalcs['monthly_full_year'][previousOldFullYear].avg : null;

    const cashFlowValues = {}
    const cashFlowValuesPeersAvg = {}
    const cashFlowValuesOldYear = {}
    const cashFlowValuesPeersAvgOldYear = {}
    // Current Year YTD Cash Flow to should match the 'Total' column in Current Year Monthly Cash Flow
    const PreviousMonthMinusCurrentMonthAmount = (opexNi, currentYear, previousYear) => {
        let returnValue = null;
        let numberOfMonths = Object.keys(currentYear).length;
        const returnObject = {}
        for (let i = 1; i <= 12; i++) {
            if (i === 1 && _.isNumber(previousYear[12])) {
                returnObject[i] = previousYear[12] - currentYear[1]
            } else if (_.isNumber(currentYear[i])) {
                returnObject[i] = currentYear[i - 1] - currentYear[i]
            } else {
                returnObject[i] = null;
            }
        }
        returnValue = Object.values(returnObject).reduce((a, b) => a + b);
        return returnValue;
    }

    const CurrentMonthMinusPreviousMonthAmount = (opexNi, currentYear, previousYear) => {
        let returnValue = null;
        let numberOfMonths = Object.keys(currentYear).length;
        const returnObject = {}
        for (let i = 1; i <= 12; i++) {
            if (i === 1 && _.isNumber(previousYear[12])) {
                returnObject[i] = currentYear[1] - previousYear[12]
            } else if (_.isNumber(currentYear[i])) {
                returnObject[i] = currentYear[i] - currentYear[i - 1]
            } else {
                returnObject[i] = null;
            }
        }
        returnValue = Object.values(returnObject).reduce((a, b) => a + b);
        return returnValue;
    }

    const commonSizeValue = (props) => {
        return props.totalRevenue ? ((props.value / props.totalRevenue) * 100).toFixed(1) : 0
    }

    const emptyRow = (i, copy, relatedCheckedKey, checked, displayChart, firstStyle, secondStyle) => {

        if (copy === 'Current Liabilities') {
            secondStyle['paddingTop'] = '20px'
        }
        let rowChecked = displayChart && checked && props.editMetrics ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''

        return (
            <tr key={i} onClick={() => props.editMetrics ? props.handleSelectAndLayout('money', 'cash_flow', relatedCheckedKey) : null}>
                {!props.pdf ? <td>{rowChecked}</td> : null}
                <td className='table-copy' style={secondStyle}>{copy}</td>
                <td className='table-copy money-table-cell' style={firstStyle}></td>
                <td className='table-copy money-table-cell' style={firstStyle}></td>
                {['Peers', 'Default:Peers'].includes(compareWith) ? <td className='table-copy money-table-cell' style={firstStyle}></td> : null}
                {['Peers', 'Default:Peers'].includes(compareWith) ? <td className='table-copy money-table-cell' style={firstStyle}></td> : null}
                <td className='table-copy' style={secondStyle}></td>
                <td className='table-copy' style={secondStyle}></td>
                <td className='table-copy' style={secondStyle}></td>
                {['Peers', 'Default:Peers'].includes(compareWith) ? <td className='table-copy' style={secondStyle}></td> : null}
                {['Peers', 'Default:Peers'].includes(compareWith) ? <td className='table-copy' style={secondStyle}></td> : null}
                <td className='table-copy' style={secondStyle}></td>
                <td className='table-copy money-table-cell' style={firstStyle}></td>
            </tr>
        )
    };

    const emptyMonthAndYTDRow = (i, copy, relatedCheckedKey, checked, displayChart, metricNameStyle, firstStyle, secondStyle) => {
        if (copy === 'Current Liabilities') {
            secondStyle['paddingTop'] = '20px'
            metricNameStyle['paddingTop'] = '20px'
        }
        secondStyle['borderLeft'] = '1px solid'
        firstStyle['borderLeft'] = '1px solid'
        let rowChecked = displayChart && checked && props.editMetrics ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''

        return (
            <tr key={i} onClick={() => props.editMetrics ? props.handleSelectAndLayout('money', 'cash_flow', relatedCheckedKey) : null}>
                {!props.pdf ? <td>{rowChecked}</td> : null}
                <td className='table-copy' style={metricNameStyle}>{copy}</td>
                <td className="money-table-cell" style={firstStyle} />
                <td className="money-table-cell" style={firstStyle} />
                <td style={secondStyle} />
                {compareWith === 'Default:None' ? null : <td style={secondStyle} />}
                {compareWith === 'Default:None' ? null : <td style={secondStyle} />}
                {compareWith === 'Default:None' ? null : <td style={secondStyle} />}
                {compareWith === 'Default:None' ? null : <td className="money-table-cell" style={firstStyle} />}
                {compareWith === 'Default:None' ? null : <td className="money-table-cell" style={firstStyle} />}
                <td style={secondStyle} />
                <td style={secondStyle} />
                {compareWith === 'Default:None' ? null : <td style={secondStyle} />}
            </tr>
        )
    }

    const Total = (props) => {
        let finalValue = parseMoney(props.value)
        return (<td className={props.cssClass} style={props.style}>
            {finalValue}
        </td>);

    }

    const CommonSizeArrowsHelper = (props) => {
        if (props.totalValue !== null && props.totalValueCompare !== null) {
            let arrow;
            const you = props.youTotalRevenue ? (props.totalValueYou / props.youTotalRevenue) : 0
            const compareTo = props.compareTotalRevenue ? (props.totalValueCompare / props.compareTotalRevenue) : 0
            arrow = CashFlowCommonSizeArrows(you, compareTo, props.keyArrBuilder)

            if (arrow === 'better' || arrow === 'best') {
                arrow = <p className='common-size-arrow-green' style={{ margin: 0, color: 'green' }}>&#9650;</p>
            } else if (arrow === 'worse' || arrow === 'worst') {
                arrow = <p className='common-size-arrow-red' style={{ margin: 0, color: 'red' }}>&#9660;</p>
            } else {
                arrow = ''
            }
            return (<td className={props.cssClass} style={props.style}>{arrow}</td>);
        } else {
            return (<td className={props.cssClass} style={props.style}></td>);
        }
    }

    const Delta = (props) => {
        let previousYearTotal = props.valuePreviousYear;
        let currentYearTotal = props.valueCurrentYear;
        let deltaValue = '$0';

        let delta = currentYearTotal - previousYearTotal;
        deltaValue = parseMoney(delta);

        if (previousYearTotal === null || currentYearTotal === null) {
            deltaValue = '-';
        }
        return (<td className='common-size-cell money-table-cell' style={props.style}>
            {deltaValue}
        </td>);
    }

    const emptyRowKeys = ['Cash flow from operating activities:', 'Cash flow from investing activities:', 'Cash flow from financing activities:']
    const borderKeys = ['Net cash flow from operating activities', 'Net cash flow from investing activities', 'Net cash flow from financing activities']
    const paddingTopKeys = ['Cash flow from investing activities:', 'Cash flow from financing activities:', 'Net change in cash and cash equivalents', 'Cash at beginning of period', 'Cash at end of period']
    const specialKeys = ['Net cash flow from operating activities', 'Net cash flow from investing activities', 'Net cash flow from financing activities', 'Net change in cash and cash equivalents', 'Cash at beginning of period', 'Cash at end of period']

    const buildMonthAndYTDRows = () => {
        let allRows = []
        let borderTopStyle, fontStyle, paddingTopStyle, metricNameStyle, backgroundStyle, firstStyle;
        let firstMonthRevenue = youPreviousYearTotalRevenue?.[firstYearMonth] || 0
        let secondMonthRevenue = youSelectedYearTotalRevenue?.[secondYearMonth] || 0
        
        props.rows.forEach((row, i) => {
            // Ex. first section 2020, last section 2021
            let paddingStyle = row.pad ? { paddingTop: '3px', paddingBottom: '20px', borderLeft: '1px solid' } : { paddingTop: '3px', borderLeft: '1px solid' }
            let metricPaddingStyle = row.pad ? { paddingTop: '3px', paddingBottom: '20px' } : { paddingTop: '3px' }
            borderTopStyle = borderKeys.includes(row.copy) ? { borderTop: 'solid 1px', minHeight: '17px' } : { borderTop: 'none' }
            paddingTopStyle = paddingTopKeys.includes(row.copy) ? { paddingTop: '3px', paddingTop: '20px' } : { paddingTop: '3px' }
            fontStyle = row.copy.toLowerCase().includes('cash') ? { textAlign: 'left', fontWeight: 'bold', fontSize: '12px', minWidth: '224px', fontStyle: row.fontStyle } : { textAlign: 'left', fontWeight: 'none', paddingLeft: '18px', minWidth: '224px', fontStyle: row.fontStyle }
            backgroundStyle = { backgroundColor: '#BFE0AE' };
            metricNameStyle = { ...fontStyle, ...metricPaddingStyle };

            firstStyle = { ...paddingStyle, ...backgroundStyle };

            if (emptyRowKeys.includes(row.copy)) {
                allRows.push(emptyMonthAndYTDRow(i, row.copy, row.relatedCheckedKey, row.checked, row.displayChart, metricPaddingStyle, firstStyle, paddingTopStyle))
            } else {
                let firstMonthVal; let secondMonthVal; let firstMonthValCS; let secondMonthValCS;
                let newerYearVals; let youSelectedYearVal; let olderYearVals; let youPreviousYearVal; let valuePYMonthlyCommonSize; let valueCYMonthlyCommonSize;
                let firstYTDVal; let secondYTDVal; let firstYTDValCS; let secondYTDValCS;

                if (compareWith === 'Default:None') {
                    let { youValues } = MonthlyCashFlowValues(row.key, monthly_calcs?.you, selectedYear, previousYear, null, null, null)
                    firstMonthVal = youValues?.[secondYearMonth] || 0
                    firstMonthRevenue = secondMonthRevenue
                    firstMonthValCS = firstMonthRevenue ? firstMonthVal / firstMonthRevenue : 0

                    newerYearVals = YTDCashFlowValues(row.key, monthly_calcs, {}, selectedYear, previousYear, ytd_months);
                    firstYTDVal = newerYearVals['youValue'];
                    firstYTDValCS = commonSizeValue({ year: selectedYear, value: firstYTDVal, totalRevenue: youSelectedYearYTDRevenue })

                } else if (compareWith === 'Default:Peers') {
                    let { youValues, compareValues } = MonthlyCashFlowValues(row.key, monthly_calcs?.you, selectedYear, previousYear, avgCalcs?.avg, selectedYear, previousYear)
                    firstMonthVal = youValues?.[secondYearMonth] || 0
                    secondMonthVal = compareValues?.[secondYearMonth] || 0
                    firstMonthValCS = firstMonthRevenue ? firstMonthVal / firstMonthRevenue : 0
                    secondMonthRevenue = compareSelectedYearTotalRevenue?.[secondYearMonth] || 0
                    secondMonthValCS = secondMonthRevenue ? secondMonthVal / secondMonthRevenue : 0

                    newerYearVals = YTDCashFlowValues(row.key, monthly_calcs, avgCalcs, selectedYear, previousYear, ytd_months);
                    firstYTDVal = newerYearVals['youValue'];
                    secondYTDVal = newerYearVals['compareValue'];

                    firstYTDValCS = commonSizeValue({ year: selectedYear, value: firstYTDVal, totalRevenue: youSelectedYearYTDRevenue })
                    secondYTDValCS = commonSizeValue({ year: selectedYear, value: secondYTDVal, totalRevenue: compareSelectedYearYTDRevenue })

                } else if (compareWith === 'Default:YOY') {
                    // Need to calculate monthly cash flow values
                    let { youValues, compareValues } = MonthlyCashFlowValues(row.key, monthly_calcs?.you, selectedYear, previousYear, monthly_calcs?.you, previousYear, twoYearsAgo)
                    firstMonthVal = compareValues?.[secondYearMonth] || 0
                    secondMonthVal = youValues?.[secondYearMonth] || 0
                    firstMonthValCS = firstMonthRevenue ? firstMonthVal / firstMonthRevenue : 0
                    secondMonthValCS = secondMonthRevenue ? secondMonthVal / secondMonthRevenue : 0

                    olderYearVals = YTDCashFlowValues(row.key, monthly_calcs, {}, previousYear, twoYearsAgo, ytd_months);
                    newerYearVals = YTDCashFlowValues(row.key, monthly_calcs, {}, selectedYear, previousYear, ytd_months);
                    firstYTDVal = olderYearVals['youValue'];
                    secondYTDVal = newerYearVals['youValue'];

                    firstYTDValCS = commonSizeValue({ year: selectedYear, value: firstYTDVal, totalRevenue: youPreviousYearYTDRevenue })
                    secondYTDValCS = commonSizeValue({ year: selectedYear, value: secondYTDVal, totalRevenue: youSelectedYearYTDRevenue })

                } else if (compareWith && compareWith.includes('Forecast')) {
                    let compareSelectedYear = props.forecastVals?.['total_revenue'] ? Object.keys(props.forecastVals['total_revenue'])[0] : null
                    let { youValues, compareValues } = MonthlyCashFlowValues(row.key, monthly_calcs?.you, selectedYear, previousYear, props.forecastVals, compareSelectedYear, previousYear, true)
                    firstMonthVal = youValues?.[secondYearMonth] || 0
                    secondMonthVal = compareValues?.[secondYearMonth] || 0
                    firstMonthValCS = firstMonthRevenue ? firstMonthVal / firstMonthRevenue : 0
                    secondMonthRevenue = youPreviousYearTotalRevenue?.[secondYearMonth] || 0
                    secondMonthValCS = secondMonthRevenue ? secondMonthVal / secondMonthRevenue : 0

                    newerYearVals = YTDCashFlowValues(row.key, monthly_calcs, props.forecastVals, selectedYear, previousYear, ytd_months, true, compareSelectedYear);
                    firstYTDVal = newerYearVals['youValue'];
                    secondYTDVal = newerYearVals['compareValue'];

                    firstYTDValCS = commonSizeValue({ year: selectedYear, value: firstYTDVal, totalRevenue: youSelectedYearYTDRevenue })
                    secondYTDValCS = commonSizeValue({ year: selectedYear, value: secondYTDVal, totalRevenue: youPreviousYearYTDRevenue })
                }

                let displayRow = row.ytdView;
                if (row.ytdView) {
                    if (row.key.includes('title') || row.key.includes('net')) {
                        displayRow = true;
                    } else {
                        displayRow = true
                    }
                }

                let rowChecked = row.displayChart && row.checked && props.editMetrics ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''

                if (compareWith === 'Default:None') {
                  allRows.push(
                        (
                            <tr key={`cashflow-mom-ytd-row-${i}`} style={displayRow ? borderTopStyle : { display: 'none' }} onClick={() => props.editMetrics ? props.handleSelectAndLayout('money', 'cash_flow', row.relatedCheckedKey) : null}>
                                {!props.pdf ? <td>{rowChecked}</td> : null}
                                <td className='table-copy' style={metricNameStyle}>
                                    {row.copy}
                                </td>
                                <td style={firstStyle} className="money-table-cell">{parseMoney(firstMonthVal)}</td>
                                <td style={firstStyle} className="common-size-cell money-table-cell">{firstMonthValCS ? `${(firstMonthValCS * 100).toFixed(1)}%` : '-'}</td>
                                <td style={paddingStyle} />
                                <Total
                                    cssClass={''}
                                    value={firstYTDVal}
                                    style={paddingStyle}
                                />
                                <td className='common-size-cell' style={paddingStyle}>
                                    {firstYTDValCS ? firstYTDValCS + '%' : '-'}
                                </td>
                            </tr>
                        )
                    )
                } else {
                    allRows.push(
                        (
                            <tr key={`cashflow-mom-ytd-row-${i}`} style={displayRow ? borderTopStyle : { display: 'none' }} onClick={() => props.editMetrics ? props.handleSelectAndLayout('money', 'cash_flow', row.relatedCheckedKey) : null}>
                                {!props.pdf ? <td>{rowChecked}</td> : null}
                                <td className='table-copy' style={metricNameStyle}>
                                    {row.copy}
                                </td>
                                <td style={firstStyle} className="money-table-cell">{parseMoney(firstMonthVal)}</td>
                                <td style={firstStyle} className="common-size-cell money-table-cell">{firstMonthValCS ? `${(firstMonthValCS * 100).toFixed(1)}%` : '-'}</td>
                                <td style={paddingStyle} />
                                <td style={paddingStyle}>{parseMoney(secondMonthVal)}</td>
                                <td style={paddingStyle} className="common-size-cell">{secondMonthValCS ? `${(secondMonthValCS * 100).toFixed(1)}%` : '-'}</td>
    
                                <td style={paddingStyle}></td>
                                <Total
                                    cssClass={'money-table-cell'}
                                    value={firstYTDVal}
                                    style={firstStyle}
                                />
                                <td className='common-size-cell money-table-cell' style={firstStyle}>
                                    {firstYTDValCS ? firstYTDValCS + '%' : '-'}
                                </td>
                                <td style={paddingStyle}></td>
                                <Total
                                    cssClass={''}
                                    value={secondYTDVal}
                                    style={paddingStyle}
                                />
                                <td className='common-size-cell' style={paddingStyle}>
                                    {secondYTDValCS ? secondYTDValCS + '%' : '-'}
                                </td>
                            </tr>
                        )
                    )
                }
            }
        });
        return allRows;
    }

    const buildYTDRows = () => {
        let allRows = []
        let borderTopStyle, fontStyle, paddingTopStyle, metricNameStyle, backgroundStyle, firstStyle;
        props.rows.forEach((row, i) => {
            let newerYearVals = YTDCashFlowValues(row.key, monthly_calcs, avgCalcs, selectedYear, previousYear, ytd_months);

            // let newerYearVals = YTDCashFlowValues(row.key, calcsYou, previousYearCalcsYou, calcsPeers, previousYearCalcsPeers);
            let youSelectedYearVal = newerYearVals['youValue'];
            let compareSelectedYearVal = newerYearVals['compareValue'];
            let olderYearVals = YTDCashFlowValues(row.key, monthly_calcs, avgCalcs, previousYear, twoYearsAgo, ytd_months);
            // let olderYearVals = YTDCashFlowValues(row.key, calcsYouOldYear, previousYearCalcsYouOldYear, calcsPeersOldYear, previousYearCalcsPeersOldYear);
            let youPreviousYearVal = olderYearVals['youValue'];
            let comparePreviousYearVal = olderYearVals['compareValue'];
            borderKeys.includes(row.copy) ? borderTopStyle = { borderTop: 'solid 1px', minHeight: '17px', paddingBottom: '17px' } : borderTopStyle = { borderTop: 'none' }
            paddingTopKeys.includes(row.copy) ? paddingTopStyle = { paddingTop: '20px' } : paddingTopStyle = { paddingTop: '3px' }
            row.copy.toLowerCase().includes('cash') ? fontStyle = { textAlign: 'left', fontWeight: 'bold', fontSize: '12px', minWidth: '224px' } : fontStyle = { textAlign: 'left', fontWeight: 'none', paddingLeft: '18px', minWidth: '224px' }
            backgroundStyle = { backgroundColor: '#BFE0AE' };
            metricNameStyle = { ...fontStyle, ...paddingTopStyle };
            firstStyle = { ...paddingTopStyle, ...backgroundStyle };

            let valuePYMonthlyCommonSize = commonSizeValue({ year: previousYear, value: youPreviousYearVal, totalRevenue: youPreviousYearYTDRevenue })
            let valuePYPeersMonthlyCommonSize = ['Peers', 'Default:Peers'].includes(compareWith) ? commonSizeValue({ year: previousYear, value: comparePreviousYearVal, totalRevenue: comparePreviousYearYTDRevenue }) : null;
            let valueCYMonthlyCommonSize = commonSizeValue({ year: selectedYear, value: youSelectedYearVal, totalRevenue: youSelectedYearYTDRevenue })
            let valueCYPeersMonthlyCommonSize = ['Peers', 'Default:Peers'].includes(compareWith) ? commonSizeValue({ year: selectedYear, value: compareSelectedYearVal, totalRevenue: compareSelectedYearYTDRevenue }) : null;
            let comparisonPY = valuePYPeersMonthlyCommonSize !== '0.00';
            let comparisonCY = valueCYPeersMonthlyCommonSize !== '0.00';
            let displayRow = row.ytdView;
            if (row.ytdView) {
                if (row.key.includes('title') || row.key.includes('net')) {
                    displayRow = true;
                } else {
                    displayRow = comparisonPY && comparisonCY;
                }
            }

            // first section 2020, last section 2021
            if (emptyRowKeys.includes(row.copy)) {
                allRows.push(emptyRow(i, row.copy, row.relatedCheckedKey, row.checked, row.displayChart, firstStyle, paddingTopStyle))
            } else {
                let rowChecked = row.displayChart && row.checked && props.editMetrics ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''

                allRows.push(
                    (
                        <tr key={i} style={displayRow ? borderTopStyle : { display: 'none' }} onClick={() => props.editMetrics ? props.handleSelectAndLayout('money', 'cash_flow', row.relatedCheckedKey) : null}>
                            {!props.pdf ? <td>{rowChecked}</td> : null}
                            <td className='table-copy' style={metricNameStyle}>
                                {row.copy}
                            </td>
                            <Total
                                cssClass={'money-table-cell'}
                                value={youPreviousYearVal}
                                style={firstStyle}
                            />
                            <td className='common-size-cell money-table-cell' style={firstStyle}>
                                {valuePYMonthlyCommonSize ? valuePYMonthlyCommonSize + '%' : '-'}
                            </td>
                            {['Peers', 'Default:Peers'].includes(compareWith)
                                ? <CommonSizeArrowsHelper
                                    cssClass={'money-table-cell'}
                                    totalValueYou={youPreviousYearVal}
                                    totalValueCompare={comparePreviousYearVal}
                                    style={firstStyle}
                                    keyArrBuilder={row.key}
                                    youTotalRevenue={youPreviousYearYTDRevenue}
                                    compareTotalRevenue={comparePreviousYearYTDRevenue}
                                    year={previousYear}
                                />
                                : null}
                            {['Peers', 'Default:Peers'].includes(compareWith)
                                ? <td className='common-size-cell money-table-cell' style={firstStyle}>
                                    {valuePYPeersMonthlyCommonSize ? valuePYPeersMonthlyCommonSize + '%' : '-'}
                                </td>
                                : null}
                            <td style={paddingTopStyle}></td>
                            <Total
                                cssClass={''}
                                value={youSelectedYearVal}
                                style={paddingTopStyle}
                            />
                            <td className='common-size-cell' style={paddingTopStyle}>
                                {valueCYMonthlyCommonSize ? valueCYMonthlyCommonSize + '%' : '-'}
                            </td>
                            {['Peers', 'Default:Peers'].includes(compareWith)
                                ? <CommonSizeArrowsHelper
                                    cssClass={''}
                                    totalValueYou={youSelectedYearVal}
                                    totalValueCompare={compareSelectedYearVal}
                                    style={paddingTopStyle}
                                    keyArrBuilder={row.key}
                                    youTotalRevenue={youSelectedYearYTDRevenue}
                                    compareTotalRevenue={compareSelectedYearYTDRevenue}
                                    year={selectedYear}
                                />
                                : null}
                            {['Peers', 'Default:Peers'].includes(compareWith)
                                ? <td className='common-size-cell' style={paddingTopStyle}>
                                    {valueCYPeersMonthlyCommonSize ? valueCYPeersMonthlyCommonSize + '%' : '-'}
                                </td>
                                : null}
                            <td style={paddingTopStyle}></td>
                            <Delta
                                valuePreviousYear={youPreviousYearVal}
                                valueCurrentYear={youSelectedYearVal}
                                style={firstStyle}
                            />
                        </tr>
                    )
                )
            }
        });
        return allRows;
    }

    const buildRows = () => {
        if (reportPeriod === 'CM + YTD') {
            return buildMonthAndYTDRows();
        } else {
            return buildYTDRows();
        }
    }

    const buildHeader = () => {
        if (reportPeriod === 'CM + YTD') {
            if (compareWith === 'Default:YOY') {
              return (
                    <tr>
                        {!props.pdf ? (<td className='edit-metrics-cell' style={{ 'borderBottom': '1px solid'}} onClick={() => props.handleEditMetrics()}>{props.editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td>) : null}
                        <td style={{ 'borderBottom': '1px solid'}}></td>
                        <td className='' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[firstYearMonth]} ${previousYearEndDigits}`}</td>
                        <td className='common-size-cell' style={{ 'borderBottom': '1px solid'}}>You</td>
                        <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
                        <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[secondYearMonth]} ${selectedYearEndDigits}`}</td>
                        <td className='common-size-cell' style={{ 'borderBottom': '1px solid'}}>You</td>
                        <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
                        <td className='' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`YTD ${previousYearEndDigits}`}</td>
                        <td className='common-size-cell' style={{ 'borderBottom': '1px solid'}}>You</td>
                        <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
                        <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`YTD ${selectedYearEndDigits}`}</td>
                        <td className='common-size-cell' style={{ 'borderBottom': '1px solid'}}>You</td>
                    </tr>
                )
            } else {
                let compareTitle = null;
                if (compareWith === 'Default:Peers') {
                    compareTitle = 'Peers'
                } else if (compareWith && compareWith.includes('Forecast')) {
                    compareTitle = props.monthlyCompareWithTitle
                }

                return (
                    <tr>
                        {!props.pdf ? (<td className='edit-metrics-cell' style={{ 'borderBottom': '1px solid' }} onClick={() => props.handleEditMetrics()}>{props.editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td>) : null}
                        <td style={{ 'borderBottom': '1px solid' }}></td>
                        <td className='' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[secondYearMonth]} ${selectedYearEndDigits}`}</td>
                        <td className='common-size-cell' style={{ 'borderBottom': '1px solid' }}>You</td>
                        <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
                        {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[secondYearMonth]} ${selectedYearEndDigits}`}</td>}
                        {compareWith === 'Default:None' ? null : <td className='common-size-cell' style={{ 'borderBottom': '1px solid' }}>{compareTitle}</td>}
                        {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>}
                        <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`YTD ${selectedYearEndDigits}`}</td>
                        <td className={`common-size-cell`} style={{ 'borderBottom': '1px solid' }}>You</td>
                        {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>}
                        {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`YTD ${selectedYearEndDigits}`}</td>}
                        {compareWith === 'Default:None' ? null : <td className='common-size-cell' style={{ 'borderBottom': '1px solid' }}>{compareTitle}</td>}
                    </tr>
                )
            }
        } else {
            return (
                <tr>
                    {!props.pdf ? (<td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td>) : null}
                    <td></td>
                    <td className='common-size-cell money-table-cell' style={{ backgroundColor: '#BFE0AE' }}>{`YTD ${clientFirstYearMonth}/${previousYear}`}</td>
                    <td className='common-size-cell money-table-cell' style={{ backgroundColor: '#BFE0AE' }}>You</td>
                    {compareWith === 'Peers' ? <td className='common-size-cell money-table-cell' style={{ backgroundColor: '#BFE0AE' }}></td> : null}
                    {compareWith === 'Peers' ? <td className='common-size-cell money-table-cell' style={{ backgroundColor: '#BFE0AE' }}>Peers</td> : null}
                    <td></td>
                    <td>{`YTD ${clientSecondYearMonth}/${selectedYear}`}</td>
                    <td className='common-size-cell'>You</td>
                    {compareWith === 'Peers' ? <td className='common-size-cell'></td> : null}
                    {compareWith === 'Peers' ? <td className='common-size-cell'>Peers</td> : null}
                    <td></td>
                    <td className='common-size-cell money-table-cell' style={{ backgroundColor: '#BFE0AE' }}>Δ Delta</td>
                </tr>
            )
        }
    }

    const buildYTDCashFlow = () => {
        if (props.pdf) {
            let pageViewClass = 'portrait-view'
            let clientNames = props.realName ? `${props.realName} / ${props.clientName}` : props.clientName
            const tabName = (props.tabName || 'Cash Flow' || '').trim().toLowerCase();
            const title = 'Cash Flow'.toLowerCase();
            let reportTitle = tabName.includes(title) ? props.tabName || 'Cash Flow' : `${props.tabName}, Cash Flow`;
            let naicsCode = finalFilters.code;
            let dataType = finalFilters.datatype;
            let revenueBand = finalFilters.revenue_band;
            let region = finalFilters.region;
            let numOfDocs = finalFilters.number_of_pros || 'All'
            const compareParts = finalFilters.compare_with.split(':');
            let compare = compareParts.length > 1 ? compareParts.slice(1).join(':').trim() : finalFilters.compare_with;
            let filtersTitle = `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Report Period: ${reportPeriod}, Compare with: ${compare}`;

            return (
                <div className={pageViewClass}>
                    <div className='money-pdf-portrait'>
                        <div>
                            <div>
                                <p className='report-annual-title'>{`${reportTitle}, ${clientNames}`}</p>
                                <p className='report-filters-title'>{filtersTitle}</p>
                            </div>
                            <div className='money-pdf-table-div'>
                                <table className='report-table sheets' id='cash-flow-ytd-pdf'>
                                    <thead>
                                        {buildHeader()}
                                    </thead>
                                    <tbody>
                                        {buildRows()}
                                        <tr><td className='footer-cell'><i>{numberCompare}</i></td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <p className='pdf-disclaimer-text'>{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
                    </div>
                </div>
            )
        } else {
            return (
                <div className='money-report-card monthly-sheet'>
                    <div className='money-report-container'>
                        <table className='report-table sheets' id='cash-flow-ytd'>
                            <thead>
                                {buildHeader()}
                            </thead>
                            <tbody>
                                {buildRows()}
                            </tbody>
                            <tfoot>
                                <tr><td><i>{numberCompare}</i></td></tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            )
        }
    }

    return buildYTDCashFlow()
}

export default MoneyYTDCashFlow;